import constants from 'constants';

const {
  ADD_WEBINARS,
  UPCOMING_WEBINARS,
  CURRENT_WEBINARS,
  PREVIOUS_WEBINARS,
  ADD_USERS_WEBINARS,
  UPDATE_WEBINAR,
  SET_TEMP_WEBINAR,
  CLEAN_WEBINARS,
  CLEAN_USERS_WEBINARS,
  CREATE_WEBINAR_SAGA,
  LOAD_ADMIN_WEBINARS_SAGA,
  // LOAD_ADMIN_WEBINAR_SAGA,
  ADD_ADMIN_WEBINARS,
  UPDATE_WEBINAR_SAGA,
  DELETE_WEBINAR_SAGA,
  ADMIN_DELETE_WEBINARS_SAGA,
  LOAD_ADMIN_DASHBOARD_WEBINARS_SAGA,
  ADD_ADMIN_DASHBOARD_WEBINARS,
  LOAD_ADMIN_USRES_WEBINARS_SAGA,
  ADD_ADMIN_USRES_WEBINARS,
  SET_WEBINARS,
  RELOAD_ALL_DASHBOARD_WEBINARS_SAGA
} = constants;

export const addWebinars = (webinarType, page, webinars, pages, count) => ({
  type: ADD_WEBINARS,
  webinarType,
  page,
  payload: webinars,
  pages,
  count
});

export const setWebinars = (webinarType, values) => ({
  type: SET_WEBINARS,
  webinarType,
  payload: values
});

export const updateWebinar = (webinar) => ({
  type: UPDATE_WEBINAR,
  payload: {
    webinar
  }
});

export const setTempWebinar = (webinar) => ({
  type: SET_TEMP_WEBINAR,
  payload: {
    webinar
  }
})

export const addUsersWebinars = (page, webinarType, webinars, pages, cpds = 0) => ({
  type: ADD_USERS_WEBINARS,
  page,
  pages,
  webinarType,
  payload: {
    webinars,
    cpds
  }
});

export const reloadDashboardWebinars = (params) => ({
  type: RELOAD_ALL_DASHBOARD_WEBINARS_SAGA,
  params
})

export const cleanWebinars = () => ({
  type: CLEAN_WEBINARS
})

export const cleanUsersWebinars = () => ({
  type: CLEAN_USERS_WEBINARS
})

export const createWebinarSaga = (webinar) => ({
  type: CREATE_WEBINAR_SAGA,
  webinar
})

export const updateWebinarSaga = (webinar) => ({
  type: UPDATE_WEBINAR_SAGA,
  webinar
})

export const deleteWebinarSaga = (webinar) => ({
  type: DELETE_WEBINAR_SAGA,
  webinar
})

export const loadAdminWebinarsSaga = (page = 1, query = {}) => ({
  type: LOAD_ADMIN_WEBINARS_SAGA,
  query,
  page
})

// export const loadAdminWebinarSaga = (webinar_id) => ({
//   type: LOAD_ADMIN_WEBINAR_SAGA,
//   webinar_id
// })

export const loadAdminUsersWebinarsSaga = (webinarId) => ({
  type: LOAD_ADMIN_USRES_WEBINARS_SAGA,
  webinarId
})

export const addAdminUsersWebinars = (values) => ({
  type: ADD_ADMIN_USRES_WEBINARS,
  payload: {
    values
  }
})

export const addAdminWebinars = (values, count, page, total_pages, query = {}) => ({
  type: ADD_ADMIN_WEBINARS,
  payload: {
    values,
    count,
    page,
    total_pages,
    query
  }
})

export const adminDeleteWebinarSaga = (webinar_ids) => ({
  type: ADMIN_DELETE_WEBINARS_SAGA,
  webinar_ids
})

export const loadAdminAdminDashboardWebinarsSaga = (page) => ({
  type: LOAD_ADMIN_DASHBOARD_WEBINARS_SAGA,
  page
})

export const addAdminDashboardWebinars = (values, count, page, total_pages, total_users) => ({
  type: ADD_ADMIN_DASHBOARD_WEBINARS,
  payload: {
    values,
    count,
    page,
    total_pages,
    total_users
  }
})



/** WEBPACK FOOTER **
 ** ./src/actions/webinars.js
 **/